<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_xiii"></a>A NOTE ON THE TEXT</h2>
<p class="indentt">In order to distinguish Dorothy Wordsworth’s writing in the Grasmere Journals from that of her other journals or her letters, and so as not to crowd the text with too many quotation marks, I have italicized the words, passages, and entries I quote from this source.</p>
<div class="pagebreak">
<p class="image"><a id="page_xv"></a><img alt="Image" class="img1" src="images/img0xv-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter003.vue?d1430c30